<template>
    <div id="password_checkin">
        <v-row no-gutters justify="center">
            <v-col :cols="cols" align="center">
                <v-text-field
                    class="txtPasswordCheckin"
                    :class="{ 'shake-horizontal': passwordIsInValid }"
                    v-model="passwordInput"
                    :append-outer-icon="passwordInput ? 'mdi-send-lock' : 'mdi-lock'"
                    :loading="loading"
                    :disabled="loading || disabled"
                    :filled="filled"
                    :outlined="outlined"
                    dense
                    hide-details
                    :clearable="clearable"
                    :placeholder="smallDevice ? $t('password') : $t('passwordEnter')"
                    type="text"
                    @click.stop=""
                    @keydown.enter="checkPassword"
                    @click:append-outer="checkPassword"
                    @click:clear="onClearPasswordInput"
                    :style="{'color': theme.textColor + '!important' }"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
import { eventMixin } from '@/utils/event-mixin';
export default {
    mixins: [layoutMixin, eventMixin],
    props: {
        spot: {},
        cols: {
            type: Number,
            default: 10
        },
        checkExternal: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: true
        },
        outlined: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: true
        },
        smallDevice: {
            type: Boolean,
            default: false
        },
        color: {},
        backgroundColor: {}
    },
    data() {
        return {
            passwordInput: '',
            passwordIsInValid: false,
            loading: false,
            colorValue: this.color,
            backgroundColorValue: this.backgroundColor
        };
    },
    mounted() {
        this.assignPseudoElementStyle();
    },
      updated() {
        // const selectedEvent = JSON.parse(localStorage.getItem('selectedEvent') || '[]');
        // this.setThemeColorValues(selectedEvent.color_theme);
         this.assignPseudoElementStyle();
     },
    methods: {
        onClearPasswordInput() {
            this.passwordInput = '';
        },
        reset(showFailAnimation) {
            if (showFailAnimation) {
                this.showFailAnimation();
            }
            this.setLoading(false);
        },

        setLoading(val) {
            this.loading = val;
            if (!val) {
                this.onClearPasswordInput();
            }
        },
        showFailAnimation() {
            this.passwordIsInValid = true;
            setTimeout(() => {
                this.passwordIsInValid = false;
            }, 1000);
        },
        checkPassword() {
            if (!this._.isEmpty(this.passwordInput)) {
                this.setLoading(true);
                setTimeout(() => {
                    if (this.checkExternal) {
                        this.$emit('check', this.passwordInput);
                    } else {
                        if (
                            this.spot &&
                            this._.isString(this.passwordInput) &&
                            this._.isString(this.spot.password) &&
                            this.passwordInput.toLowerCase() == this.spot.password.toLowerCase()
                        ) {
                            this.$emit('success', this.passwordInput);
                        } else {
                            this.showFailAnimation();
                        }
                        this.setLoading(false);
                    }
                }, 1000);
            }
        },
        assignPseudoElementStyle() {
            this.colorValue = this.theme.textColor;
            this.backgroundColorValue = this.theme.backgroundColor;
            document.documentElement.style.setProperty('--color', this.colorValue);
            document.documentElement.style.setProperty('--background-color', this.backgroundColorValue);
        }
    }
};
</script>

<style lang="scss">
.txtPasswordCheckin,
.txtPasswordCheckin > .v-icon,
.txtPasswordCheckin > * {
    /*color:white!important;*/
}
.shake-horizontal {
    -webkit-animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
    animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}

@-webkit-keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
@keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
#password_checkin {
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background-color: var(--background-color);
        border: 1px solid var(--color);
    }

    .v-input__control {
        border-bottom-color: var(--color) !important;
        border-left-color: var(--color) !important;
        border-right-color: var(--color) !important;
        border-top-color: var(--color) !important;
    }

    .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        color: var(--color);
    }

    .theme--light.v-input input,
    .theme--light.v-input textarea {
        color: var(--color);
    }

    .v-input__slot {
        &:hover {
            background-color: transparent;
            cursor: pointer;
        }
    }
    .v-icon {
        color: var(--color) !important;
    }

    .theme--light.v-progress-linear {
        color: var(--color);
    }

    .primary {
        background-color: var(--color) !important;
        border-color: var(--color) !important;
    }

    .v-input {
        color: var(--color);
        caret-color: var(--color) !important;
        ::placeholder {
           color: var(--color); 
         }
    }
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: var(--color);
    }
}
 .v-btn--active span {
        color: transparent !important;
    }

.helpSystemOverlay {
    .v-card__text {
        background-color: var(--background-color);
    }
}
</style>
